import { render, staticRenderFns } from "./sendMailRequest.vue?vue&type=template&id=d5962ca0&scoped=true&"
import script from "./sendMailRequest.vue?vue&type=script&lang=js&"
export * from "./sendMailRequest.vue?vue&type=script&lang=js&"
import style0 from "./sendMailRequest.vue?vue&type=style&index=0&id=d5962ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5962ca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5962ca0')) {
      api.createRecord('d5962ca0', component.options)
    } else {
      api.reload('d5962ca0', component.options)
    }
    module.hot.accept("./sendMailRequest.vue?vue&type=template&id=d5962ca0&scoped=true&", function () {
      api.rerender('d5962ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/sendMailRequest.vue"
export default component.exports